export var createTransition = function createTransition(event, check) {
  return {
    event: event,
    check: check
  };
};